import type { PointCloudRegistrationState } from '@/state/useViewerStore';
import { Button, Card, Chip, Icon, Stack, Text } from '@/design';
import { registrationLabel } from './model';

interface PointCloudRegistrationDiagnosticsProps {
  registrationState: PointCloudRegistrationState;
  onOpenAudit(): void;
}

export function PointCloudRegistrationDiagnostics({
  registrationState,
  onOpenAudit,
}: PointCloudRegistrationDiagnosticsProps) {
  const status = registrationLabel(registrationState);

  return (
    <Card
      level={2}
      header="Registration diagnostics"
      actions={(
        <Button variant="ghost" onClick={onOpenAudit} aria-label="Open registration diagnostics in audit">
          <Icon name="history" size={20} decorative />
          <span>Open audit</span>
        </Button>
      )}
    >
      <Stack direction="column" gap={1}>
        <Chip icon={status.icon} label={status.label} variant={status.variant} />
        {registrationState !== 'registered' ? (
          <Text as="p" variant="caption" style={{ margin: 0 }}>
            Point-cloud alignment requires review before trusted measurement.
          </Text>
        ) : (
          <Text as="p" variant="caption" style={{ margin: 0 }}>
            Registration is healthy.
          </Text>
        )}
      </Stack>
    </Card>
  );
}
